import { MoonSegmentedControl } from "./MoonSegmentedControl";

/**
 * The unit choice inside a value field: the shared segmented control in its
 * compact rounded shape. Pass it as `trailing` to `MoonValueInput` or
 * `MoonNumericField` when a value can be in more than one unit (AMH in ng/mL
 * or pmol/L, stock in pens or vials). A value with one unit takes a `suffix`
 * instead.
 */
export function MoonUnitToggle<T extends string>({
  units,
  value,
  onChange,
  getLabel,
  accessibilityLabel,
  action,
  disabled,
}: {
  units: readonly T[];
  /** The chosen unit, or null while none of `units` is chosen. */
  value: T | null;
  onChange: (unit: T) => void;
  /** The visible label of a unit, when it is not the unit itself. */
  getLabel?: (unit: T) => string;
  /** Names the choice for assistive tech, such as "Unit". */
  accessibilityLabel?: string;
  /** Stable analytics identifier for a press on any unit. */
  action?: string;
  disabled?: boolean;
}) {
  return (
    <MoonSegmentedControl
      tabs={units.map((unit) => ({
        value: unit,
        label: getLabel ? getLabel(unit) : unit,
        ...(action ? { action } : null),
      }))}
      active={value}
      onChange={onChange}
      shape="rounded"
      optionRole="radio"
      accessibilityLabel={accessibilityLabel}
      disabled={disabled}
      style={{ marginTop: 0 }}
    />
  );
}
